import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BillingService } from '../billing/billing.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-billing-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './billing-details.component.html',
  styleUrls: ['./billing-details.component.scss'],
})
export class BillingDetailsComponent implements OnInit {
  billing: any;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private billingService: BillingService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const billingId = this.route.snapshot.paramMap.get('id');
    if (billingId) {
      this.loadBillingDetails(billingId);
    } else {
      this.toastr.error('Billing ID not found in the URL.', 'Error');
    }
  }

  loadBillingDetails(id: string) {
    this.isLoading = true;
    this.billingService.getBillingById(id).subscribe({
      next: (data: any) => {
        this.billing = data; // Assuming the API returns a single billing object
        this.isLoading = false;
        console.log('Fetched billing details:', this.billing);
      },
      error: (err: any) => {
        this.toastr.error('Failed to fetch billing details.', 'Error');
        this.isLoading = false;
        console.error('Error fetching billing details', err);
        this.billing = null;
      },
    });
  }

  formatCurrency(value: string | number): string {
    const num =
      typeof value === 'string' ? parseFloat(value || '0') : value || 0;
    return `₹${num.toFixed(2)}`;
  }

  goBack() {
    this.router.navigate(['/billinglist']);
  }
}
